import {ApiClient as Api} from '@hconnect/apiclient'
import {useNotification} from '@hconnect/uikit'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {SlaTrackingQueryKey} from '../../types'

type Props = {
  plantUpmId: string
  kpiValueId: string
}

export const useDeleteSlaKpiComment = ({plantUpmId, kpiValueId}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()
  const {notify} = useNotification()

  return useMutation<void, AxiosError, {commentId: string}>({
    mutationFn: async ({commentId}) => {
      const path = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values/${kpiValueId}/comments/${commentId}`
      await Api.axiosInstance.delete(path)
    },
    onSuccess: () => {
      notify('success', t('comments.message.deleteSuccess'))
      void client.invalidateQueries({
        queryKey: [SlaTrackingQueryKey.SlaKpiTabValueEvents, plantUpmId, kpiValueId]
      })
      void client.invalidateQueries({queryKey: [SlaTrackingQueryKey.SlaKpiTabValues, plantUpmId]})
      void client.invalidateQueries({queryKey: [SlaTrackingQueryKey.SlaKpiComments]})
    },
    onError: () => {
      notify('error', t('comments.message.failedToDeleteComment'))
    }
  })
}
